export function buildL18nErrorCode<T>(code: T) {
  return `errors.${code}`;
}

export function buildL18nErrorTitleCode<T>(code: T) {
  return `errors.messageBoxTitle.${code}`;
}
